import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        account_id      : 0,
        project_id      : 0,
        content         : '',
        feedback_type   : '',
        is_disabled     : false
    },
    isEnabled: function(feedback_type) {
        var feedback_types = this.get('feedback_type').split(',').map((type) => parseInt(type, 10));

        return !this.get('is_disabled') && feedback_types.includes(feedback_type);
    }
});